import { Box, CheckBox, IconNew, ModBox, SpacerNew, Text } from '@jfs/ui-new'
import React from 'react'

const DefaultCheckNDelete = React.memo(({ isEdit, isChecked, onCheckedChange, onDelete }: any) => {
  const handleOnPress = () => {
    onCheckedChange && onCheckedChange(isChecked)
  }
  return (
    <Box flexDirection={'row'} alignItems={'center'}>
      <ModBox show={isEdit} alignItems={'center'} justify={'center'} minWidth={100}>
        <CheckBox checked={isChecked} onChange={onCheckedChange} textLabel={'Default'} iconSize={16} />
      </ModBox>
      <ModBox
        show={false}
        alignItems={'center'}
        justify={'center'}
        direction={'row'}
        onPress={handleOnPress}
        underlayColor={'GRAY_SHADOW'}>
        <IconNew
          id={isChecked ? 'SUCCESSFUL_FILLED' : 'RADIOBUTTON_OFF'}
          color={isChecked ? 'GREEN' : 'DISABLED_GREY'}
        />
        <SpacerNew size={8} direction={'horizontal'} />
        <Text title="Default" fontSize={14} fontFamily={'jiotype-medium'} />
      </ModBox>
      <SpacerNew size={20} direction={'horizontal'} />
      <ModBox
        show={isEdit}
        width={32}
        borderWidth={1}
        borderColor={'GRAY_BORDER'}
        borderRadius={4}
        alignItems={'center'}
        justifyContent={'center'}
        onPress={onDelete}>
        <IconNew id={'DELETE'} color={'BLUE'} />
      </ModBox>
    </Box>
  )
})

export { DefaultCheckNDelete }
